import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import AttendActivity from './AttendActivity'
import * as attendActivityApi from 'LiveBoard/api/attendActivity'
import { createUniqueId, DEFAULT_LABEL } from './helpers'

const UPDATE_INTERVAL = 10000

const AttendActivityContainer = (props) => {
  const [showAttendActivity, setShowAttendActivity] = useState(props.attendActivityConfig.show)
  const guid = createUniqueId()

  const activityParams = {
    boardId: props.boardId,
    attendanceGuid: guid,
    activityType: props.activityType
  }
  const didUserAttended = useRef(false)

  const updateAttendActivity = () => {
    didUserAttended.current &&
      attendActivityApi.updateAttendActivity(activityParams)
  }

  useEffect(() => {
    showAttendActivity && !props.hasAttendActivity && handleJoin()

    const updateEndTime = setInterval(() => {
      updateAttendActivity()
    }, UPDATE_INTERVAL)

    window.addEventListener('beforeunload', updateAttendActivity)

    return () => {
      window.removeEventListener('beforeunload', updateAttendActivity)
      clearInterval(updateEndTime)
      updateAttendActivity()
    }
  }, [])

  const setUserAttended = () => {
    didUserAttended.current = true
  }

  const handleJoin = () => {
    setShowAttendActivity(false)
    props.onUserInteracted && props.onUserInteracted()
    attendActivityApi.attendActivity(activityParams)
      .then(setUserAttended)
  }

  return showAttendActivity && props.hasAttendActivity &&
    <AttendActivity
      onJoin={handleJoin}
      themeColorHex={props.themeColorHex}
      label={props.attendActivityConfig.label || DEFAULT_LABEL} />
}

AttendActivityContainer.propTypes = {
  attendActivityConfig: PropTypes.object,
  themeColorHex: PropTypes.string,
  boardId: PropTypes.number.isRequired,
  activityType: PropTypes.number.isRequired,
  hasAttendActivity: PropTypes.bool,
  onUserInteracted: PropTypes.func
}

AttendActivityContainer.defaultProps = {
  attendActivityConfig: {
    show: false
  },
  themeColorHex: '#418bba',
  hasAttendActivity: true
}

export default AttendActivityContainer
